import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CurrencyFormat from '../components/CurrencyFormat';
import PageTitle from '../components/PageTitle';
import Row from '../components/Row';
import StatsCard from '../components/StatsCard';
import { Reducers } from '../store/reducers';
import { Counter, CounterState } from '../store/reducers/countersReducer';

export default function Home() {
    const invoices = useSelector((state: Reducers) => state.invoices.data);
    const counters = useSelector((state: Reducers) => state.counters.data);
    const account = useSelector((state: Reducers) => state.account);

    const navigate = useNavigate();

    const [notPaidInvoices, setNotPaidInvoices] = useState(0);
    const [totalCounters, setTotalCounters] = useState(0);
    const [balance, setBalance] = useState(0);
    const [totalDebit, setTotalDebit] = useState(0);

    function totalDebitFunc() {
        let total = 0;
        for (let i = 0; i < invoices.length; i++) {
            const invoice = invoices[i];
            if (invoice.paidOut === false) {
                total += invoice.amount
            }
        }
        setTotalDebit(total);
    }
    useEffect(() => {
        setNotPaidInvoices(invoices.filter(invoice => invoice.paidOut === false).length);
        setTotalCounters(counters.length)
        totalDebitFunc();
    }, [invoices, counters, account]);

    return (
        <>
            <PageTitle>
                Portal do cliente da EDM
            </PageTitle>
            <Row>
                <StatsCard desc="Facturas pendentes" number={notPaidInvoices + ""} icon='file-invoice' iconColor="#fff" backgroundIconColor='#f009'>
                </StatsCard>

                <StatsCard desc="Total em dívida" number={<CurrencyFormat value={totalDebit}></CurrencyFormat>} icon='file-invoice-dollar' iconColor="#fff" backgroundIconColor='#00f9' >
                </StatsCard>
                <StatsCard desc="Contadores Registrados" number={totalCounters + ""} icon='stopwatch-20' iconColor="#fff" backgroundIconColor='#E3642F'>
                </StatsCard>
                <StatsCard desc="Crédito" number={<CurrencyFormat value={account.balance}></CurrencyFormat>} icon='money-bill' iconColor="#fff" backgroundIconColor='#0f09'>
                </StatsCard>

            </Row>
            <div className="card table-card">
                <div className="card-header"><h3>Últimas facturas</h3></div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        Número
                                    </th>
                                    <th>
                                        Contador
                                    </th>
                                    <th>
                                        Montante
                                    </th>
                                    <th>
                                        Data
                                    </th>

                                    <th>
                                        Estádo
                                    </th>

                                    <th>
                                        Acção
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map(invoice => {
                                    return (
                                        <tr key={invoice.number}>
                                            <td>{invoice.number}</td>
                                            <td>{invoice.counter}</td>
                                            <td>
                                                <CurrencyFormat value={invoice.amount} />
                                            </td>
                                            <td>{invoice.date}</td>
                                            {invoice.paidOut ?
                                                <td style={{ color: "green" }}>
                                                    Pago
                                                </td> :
                                                <td style={{ color: "red" }}>
                                                    Não pago
                                                </td>
                                            }
                                            <td>
                                                <button className="button button-success"
                                                    onClick={() => { navigate("/invoice/show", { state: { invoice } }) }}>
                                                    <i className='fa fa-eye'></i>
                                                </button>
                                            </td>

                                        </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}
